import { get, writable } from 'svelte/store';

import positions from './positions';

let notificationCount = 0;

const isNotificationValid = (notification) => {
  return notification && typeof notification.text === 'string' && positions.includes(notification.position);
};

const addNotification = (notification, update) => {
  if (!isNotificationValid(notification)) {
    throw new Error('Notification object is not valid');
  }

  const { id = notificationCount++, autohide = +notification.autohide, ...rest } = notification;

  update((notifications) => [
    ...notifications,
    {
      id,
      autohide,
      ...rest
    }
  ]);
};

const removeNotification = (notificationId, update) =>
  update((notifications) => notifications.filter(({ id }) => id !== notificationId));

const clearNotifications = (set) => set([]);

const createNotificationsStore = () => {
  const { subscribe, set, update } = writable([]);

  const getNotifications = () => get({ subscribe });

  return {
    subscribe,
    getNotifications,
    addNotification: (notification) => addNotification(notification, update),
    removeNotification: (notificationId) => removeNotification(notificationId, update),
    clearNotifications: () => clearNotifications(set)
  };
};

export default createNotificationsStore();
